export default function interruptAuth(token, navigate) {
    if (!token) {
        navigate("/dashboard/login")
        return true
    }
    return false
}